export default {
    timeSince(time, or){
        if(!time){
            return or;
        }

        const now = new Date().getTime();
        const value = parseInt(Math.abs(now - time) / 1000);
        const minutes = parseInt((value / 60) % 60);
        let hours = (value / 60 / 60) % 24;
        hours = hours < 1 ? 0 : parseInt(hours);
        let days = value / (60 * 60 * 24);
        days = days < 1 ? 0 : parseInt(days);
        return `${days > 0 ? `${days}d ` : ''} ${hours > 0 ? `${hours}h ` : ''} ${minutes > 0 || (days === 0 && hours === 0) ? `${minutes}m` : ''}`;
    }

}
